import { mapGetters } from 'vuex'
import journal from '../../../../api/journal'
export default {
  data() {
    return {
      params: {},
      rules: {}
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId'
    })
  },
  mounted() {
    this.getRules()
  },
  methods: {
    async submit() {
      const flag = this.$refs['journal-add-form-first'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          released: false
        })
        const id = await journal.addFirst(data)
        this.$router.push('/publishing/journals/add/' + id)
      }
    },
    getRules() {
      this.rules = {
        fullName: [
          {
            required: true,
            message:
              'Journal’s Full Name' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        name: [
          {
            required: true,
            message:
              'Journal’s Abbreviation' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        nameDatabase: [
          {
            required: true,
            message:
              'Journal’s Abbreviation (Database)' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        // contactEmail: [
        //   {
        //     required: true,
        //     message: 'Contact Email' + this.LANGUAGE[this.language].noEmpty
        //   },
        //   {
        //     type: 'email',
        //     message: this.LANGUAGE[this.language].enterCorrent + 'Contact Email'
        //   }
        // ],
        info: [
          {
            required: true,
            message: 'Introduction' + this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    }
  }
}
